// action types
import { createRequestTypes } from "../../utils";

// Spawn CRUD
export const CREATE_SPAWN = createRequestTypes("CREATE_SPAWN");
export const UPDATE_SPAWN = createRequestTypes("UPDATE_SPAWN");
export const DELETE_SPAWN = createRequestTypes("DELETE_SPAWN");
export const GET_SPAWNS_BY_ORG = createRequestTypes("GET_SPAWNS_BY_ORG");
export const TOGGLE_SPAWN_CONTAMINATION = createRequestTypes("TOGGLE_SPAWN_CONTAMINATION");
export const TOGGLE_SPAWN_ACTIVE = createRequestTypes("TOGGLE_SPAWN_ACTIVE");
export const TOGGLE_SPAWN_DEPLETION = createRequestTypes("TOGGLE_SPAWN_DEPLETION");
export const GET_SPAWN_DETAIL = createRequestTypes("GET_SPAWN_DETAIL");
export const GET_SPAWN_LINEAGE = createRequestTypes("GET_SPAWN_LINEAGE");

// UI state
export const SET_SELECTED_SPAWN = 'SET_SELECTED_SPAWN';
export const RESET_SPAWNS_STATE = 'RESET_SPAWNS_STATE';

// ----------------------------------------------------------------------
// Action Creators - Spawn CRUD
// ----------------------------------------------------------------------

export const createSpawnRequest = (data) => ({
  type: CREATE_SPAWN.REQUEST,
  payload: data,
});

export const createSpawnSuccess = (data) => ({
  type: CREATE_SPAWN.SUCCESS,
  payload: { data },
});

export const createSpawnFailure = (error) => ({
  type: CREATE_SPAWN.FAILURE,
  payload: error,
});

export const updateSpawnRequest = (id, data) => ({
  type: UPDATE_SPAWN.REQUEST,
  payload: { id, data },
});

export const updateSpawnSuccess = (data) => ({
  type: UPDATE_SPAWN.SUCCESS,
  payload: { data },
});

export const updateSpawnFailure = (error) => ({
  type: UPDATE_SPAWN.FAILURE,
  payload: error,
});

export const deleteSpawnRequest = (id) => ({
  type: DELETE_SPAWN.REQUEST,
  payload: id,
});

export const deleteSpawnSuccess = (id) => ({
  type: DELETE_SPAWN.SUCCESS,
  payload: { id },
});

export const deleteSpawnFailure = (error) => ({
  type: DELETE_SPAWN.FAILURE,
  payload: error,
});

export const getSpawnsByOrgRequest = (organizationId) => ({
  type: GET_SPAWNS_BY_ORG.REQUEST,
  payload: organizationId,
});

export const getSpawnsByOrgSuccess = (data) => ({
  type: GET_SPAWNS_BY_ORG.SUCCESS,
  payload: { data },
});

export const getSpawnsByOrgFailure = (error) => ({
  type: GET_SPAWNS_BY_ORG.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// UI State Actions
// ----------------------------------------------------------------------

export const setSelectedSpawn = (spawn) => ({
  type: SET_SELECTED_SPAWN,
  payload: spawn,
});

export const resetSpawnsState = () => ({
  type: RESET_SPAWNS_STATE,
});

// Get Spawn Detail
export const getSpawnDetailRequest = (id) => ({
  type: GET_SPAWN_DETAIL.REQUEST,
  payload: id,
});

export const getSpawnDetailSuccess = (data) => ({
  type: GET_SPAWN_DETAIL.SUCCESS,
  payload: { data },
});

export const getSpawnDetailFailure = (error) => ({
  type: GET_SPAWN_DETAIL.FAILURE,
  payload: error,
});

export const clearSpawnDetail = () => ({
  type: 'CLEAR_SPAWN_DETAIL',
});

// Toggle Contamination
export const toggleSpawnContaminationRequest = (id, contaminationFree) => ({
  type: TOGGLE_SPAWN_CONTAMINATION.REQUEST,
  payload: { id, contaminationFree },
});

export const toggleSpawnContaminationSuccess = (data) => ({
  type: TOGGLE_SPAWN_CONTAMINATION.SUCCESS,
  payload: { data },
});

export const toggleSpawnContaminationFailure = (error) => ({
  type: TOGGLE_SPAWN_CONTAMINATION.FAILURE,
  payload: error,
});

// Toggle Active
export const toggleSpawnActiveRequest = (id, active) => ({
  type: TOGGLE_SPAWN_ACTIVE.REQUEST,
  payload: { id, active },
});

export const toggleSpawnActiveSuccess = (data) => ({
  type: TOGGLE_SPAWN_ACTIVE.SUCCESS,
  payload: { data },
});

export const toggleSpawnActiveFailure = (error) => ({
  type: TOGGLE_SPAWN_ACTIVE.FAILURE,
  payload: error,
});

// Toggle Depletion
export const toggleSpawnDepletionRequest = (id, isDepleted) => ({
  type: TOGGLE_SPAWN_DEPLETION.REQUEST,
  payload: { id, isDepleted },
});

export const toggleSpawnDepletionSuccess = (data) => ({
  type: TOGGLE_SPAWN_DEPLETION.SUCCESS,
  payload: { data },
});

export const toggleSpawnDepletionFailure = (error) => ({
  type: TOGGLE_SPAWN_DEPLETION.FAILURE,
  payload: error,
});

// Get Spawn Lineage
export const getSpawnLineageRequest = (id) => ({
  type: GET_SPAWN_LINEAGE.REQUEST,
  payload: id,
});

export const getSpawnLineageSuccess = (data) => ({
  type: GET_SPAWN_LINEAGE.SUCCESS,
  payload: { data },
});

export const getSpawnLineageFailure = (error) => ({
  type: GET_SPAWN_LINEAGE.FAILURE,
  payload: error,
});
